import { clsx } from 'clsx';

import { Box } from '@material-ui/core';
import CustomChip from './../custom-chip/CustomChip';
import CustomButton from '../buttons/custom-button';

import { useFormatMessage } from '../../../intl/intl';
import FilterMenuIcon from './../../icons/menu/FilterMenuIcon';
import useStyles from './CustomAdvancedFilterToolbar.styles';

function CustomAdvancedFilterToolbar(props) {
  const { classes = {}, onClick, selectedFilterOptions = [], title } = props;
  const showFilterText = useFormatMessage({ id: 'global.showFilters' });
  const defaultTitle = useFormatMessage({ id: 'global.showAdvancedFilter' });
  const _title = title || defaultTitle;
  const _classes = useStyles();
  return (
    <aside className={clsx(_classes.root, classes?.root)}>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='flex-start'
        gridGap='0.5rem'
      >
        <CustomButton
          classes={{ submitButton: _classes.showFiltersButton }}
          color='primary'
          fullWidth={false}
          onClick={onClick}
          text={showFilterText}
          variant='outlined'
        />

        <div
          aria-label='list of selected stores by filter'
          className={clsx(_classes.chipsRoot, classes?.chipsRoot)}
        >
          {selectedFilterOptions.map((filterOption, index) => (
            <CustomChip
              key={index}
              label={filterOption.label}
              onDelete={filterOption.onDelete}
            />
          ))}
        </div>
      </Box>
    </aside>
  );
}

export default CustomAdvancedFilterToolbar;
